import React from 'react'

import type { CSSObject } from '@emotion/react'
import {
  AlignItems,
  Box,
  Col,
  Color,
  Display,
  FontWeight,
  Grid,
  Space,
  Text,
  TextAlign,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

import { CONTROL_DISCOUNT_VALUES } from '../boxPricesConfig'

type DiscountPerWeekNDDProps = {
  discountValues?: string[]
}

export const DiscountPerWeekNDD = ({
  discountValues = CONTROL_DISCOUNT_VALUES,
}: DiscountPerWeekNDDProps) => {
  const discountBoxes = [
    'Today',
    '2nd box',
    '3rd box',
    '4th box',
    '5th box',
    '6th box',
    '7th box',
    '8th box',
  ]

  const StyledGrid = withCitrusTheme(Grid, (theme) => ({
    ...(theme.responsiveSpacing([0, 0, 8], ['paddingLeft']) as CSSObject),
  }))

  return (
    <Box display={Display.Flex} data-testid="discount-per-week-ndd">
      <StyledGrid columnGap={2}>
        {discountBoxes.map((box, index) => (
          <Col key={box} size={[3, 3, 1, 1]}>
            <Box>
              <Box
                bg={box !== 'Today' ? Color.ColdGrey_500 : Color.Primary_600}
                borderRadius={1.5}
                width="64px"
                height="64px"
                display={Display.Flex}
                alignItems={AlignItems.Center}
              >
                <Text
                  size={5}
                  color={Color.White}
                  fontWeight={FontWeight.Bold}
                  textAlign={TextAlign.Center}
                >
                  {discountValues[index]}
                </Text>
              </Box>

              <Space size={1} />

              <Text size={2} color={Color.ColdGrey_800} textAlign={TextAlign.Center}>
                {box}
              </Text>
              <Space size={2} />
            </Box>
          </Col>
        ))}
      </StyledGrid>
    </Box>
  )
}
